import React from "react";

const CustomStepper = ({
	steps,
	activeStep,
	setActiveStep,
	className,
}: {
	steps: { label: string; optional?: boolean; disabled?: boolean }[];
	activeStep: number;
	setActiveStep: (step: number) => void;
	className?: string;
}) => {
	return (
		<div className={className}>
			<div className="stepper">
				{steps.map((step, index) => (
					<React.Fragment key={index}>
						{index < activeStep ? (
							<div
								className={`step complete`}
								title={step.label}
								onClick={() => {
									if (step.disabled) return;
									setActiveStep(index);
								}}
								aria-disabled={step.disabled}
								style={{ cursor: step.disabled ? "default" : "pointer" }}
							>
								<div className={`step-index complete`}>
									<img src={`/icon/checkmark.svg`} alt={"complete icon"} />
								</div>
							</div>
						) : (
							<div
								className={`step ${index === activeStep ? "active" : ""}`}
								title={step.label}
								onClick={() => {
									if (step.disabled) return;
									setActiveStep(index);
								}}
								aria-disabled={step.disabled}
								style={{ cursor: step.disabled ? "default" : "pointer" }}
							>
								<div
									className={`step-index ${
										index === activeStep ? "active" : ""
									}`}
								>
									{index + 1}
								</div>
							</div>
						)}

						{index < steps.length - 1 && (
							<div
								className={`connector ${index < activeStep ? "active" : ""}`}
							></div>
						)}
					</React.Fragment>
				))}
			</div>
			<div
				className="stepper-labels"
				style={{
					display: "flex",
					justifyContent: "space-between",
					paddingBottom: "30px",
				}}
			>
				{steps.map((step, index) => (
					<div
						key={index}
						className="step-name"
						style={{
							textAlign:
								index === 0
									? "left"
									: index === steps.length - 1
										? "right"
										: "center",
						}}
					>
						{step.label}
					</div>
				))}
			</div>
		</div>
	);
};

export default CustomStepper;
